import React from "react";
import licenseImg from "../assets/image/tourism-license.png";

export default function TourismLicense() {
  return (
    <div className="container py-4" dir="rtl">
      {/* العنوان */}
       <div className="text-center mb-3">
        <h1 className="h4 mb-1 fw-semibold">الترخيص السياحي</h1>
        <p className="text-muted m-0">
          هذا المستند يوضح بيانات الترخيص السياحي الخاص بالتنظيم. رقم الترخيص: <strong>73104281</strong>
        </p>
      </div>

      <div
        className="d-flex align-items-center justify-content-center"
        style={{
          border: "none",
          boxShadow: "none",
          overflow: "hidden",
          minHeight: "40vh",
        }}
      >
        <img
          src={licenseImg}
          alt="صورة الترخيص السياحي"
          style={{
            // احتواء كامل للصورة داخل مساحة العرض
            maxWidth: "100%",
            maxHeight: "80vh",
            objectFit: "contain",
            display: "block",
            border: "none",
            boxShadow: "none",
          }}
          loading="lazy"
        />
      </div>
    </div>
  );
}
